import React from 'react';
import {connectWithCore} from 'framework/hocs';
import {ConfigFragment as _ConfigFragment} from 'app-ui-componentlibrary/dist/componentLibrary/layout/ConfigFragment';
import contentMap from 'componentLibrary';

export const ConfigFragment = (props) => <_ConfigFragment {...props} {...{contentMap}} />;
export const DynamicFragment = connectWithCore(ConfigFragment);
export default DynamicFragment;
